import { connect } from 'react-redux';
import { withStyles } from '@mui/styles';
import SubscriptionPackage from './SubscriptionPackage';
import styles from './styles';

function mapStateToProps(state) {
  const {
    subscriptions,
    isLoadingSubscriptions,
    errorSubscriptions,
    subscriptionsMessage,
  } = state.master;
  return {
    subscriptions,
    isLoadingSubscriptions,
    errorSubscriptions,
    subscriptionsMessage,
  };
}

const Styled = withStyles(styles)(SubscriptionPackage);

export default connect(
  mapStateToProps,
)(Styled);
